import {PremiumService, Service} from "@App/types";
import {PremiumServices, Services} from "@App/types/enums";

export const ServiceIsVehicleReturn = (service: Service) => {
    return service?.id === Services.VEHICLERETURN;
}

export const ServiceIsCertificate = (service: Service) => {
    return service?.id === Services.CERTIFICATE;
}

export const ServiceIsGlass = (service: Service) => {
    return service?.id === Services.GLASS;
}

export const ServiceIsInspection = (service: Service) => {
    return service?.id === Services.INSPECTION || service?.id === Services.INSPECTIONANDWHEELCHANGE;
}

export const ServiceIsAppointment = (service: Service) => {
    return service?.id === Services.APPOINTMENT;
}

export const ServiceIsEVehicleAppointment = (service: Service) => {
    return service?.id === Services.EVEHICLEAPPOINTMENT;
}

export const ServiceIsGaragesNearby = (service: Service) => {
    return service?.id === Services.GARAGESNEARBY;
}

export const ServiceIsWheelChange = (service: Service) => {
    return service?.id === Services.WHEELCHANGE;
}

export const ServiceIsAutoAbo = (service: Service) => {
    return service?.id === Services.AUTOABO;
}
export const ServiceIsWheelChangeTiresStored = (service: Service) => {
    return service?.id === Services.WHEELCHANGETIRESSTORED;
}

export const ServiceIsTireStorage = (service: Service) => {
    return service?.id === Services.TIRESTORAGE;
}

export const ServiceIsElectronicLicenseControl = (service: Service) => {
    return service?.id === Services.ELECTRONICLICENSECONTROL;
}

export const PremiumServiceIsCollectAndReturn = (premiumService: PremiumService) => {
    return premiumService.type === 'CollectAndReturn';
}

export const PremiumServiceIsRentalCar = (premiumService: PremiumService) => {
    return premiumService.type === 'ReplacementVehicle';
}

export const ServiceShouldDisplayReviews = (service: Service) => {
    return (service?.display_reviews && service?.pivot.reviews_enabled);
}

export const ServiceHasCustomSearchHeadline = (service: Service) => {
    return service?.pivot.display_search_headline?.length > 0;
}

export const ServiceHasCustomImagePlaceholder = (service: Service) => {
    return service?.pivot.display_image_placeholder?.length > 0;
}


export const ServiceRequiresAdditionalInformation = (service: Service) => {
    return service?.requires_additional_information;
}

export const PremiumServiceIsCollectAndReturnId = (service: PremiumService) => {
    return service.id.toString() === PremiumServices.COLLECTANDRETURN.toString();
}

export const PremiumServiceIsReplacementVehicleId = (service: PremiumService) => {
    return service.id.toString() === PremiumServices.REPLACEMENTVEHICLE.toString();
}

export const ServiceIsAdditionalTireServices = (service: Service) => {
    return service?.id === Services.ADDITIONALTIRESERVICES;
}

export const ServiceIsWheelReplacement = (service: Service) => {
    return service?.id === Services.WHEELREPLACEMENT;
}

export const PremiumServiceTypeIsSubService = (premiumService: PremiumService) => {
    return premiumService.service_type === 'sub-service';
}

